var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.00265503,
    width: 35,
    height: 23.3333,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2859 7.8668L15.6534 15.7638H13.6793L15.3121 7.8668H17.2859ZM25.5915 12.9659L26.6308 10.0003L27.2288 12.9659H25.5915ZM27.794 15.7638H29.62L28.0266 7.8668H26.3412C25.9625 7.8668 25.6429 8.09475 25.5006 8.44617L22.539 15.7638H24.612L25.0236 14.5846H27.5563L27.794 15.7638ZM22.6419 13.1854C22.6503 11.1011 19.8565 10.9864 19.8758 10.0553C19.8816 9.77163 20.1427 9.4707 20.713 9.39346C20.9963 9.35522 21.7752 9.32598 22.6597 9.74713L23.0061 8.07251C22.531 7.89405 21.9197 7.72234 21.1593 7.72234C19.2082 7.72234 17.8349 8.79585 17.8233 10.333C17.811 11.4698 18.8037 12.1041 19.5517 12.482C20.3207 12.8692 20.5792 13.1171 20.5758 13.4633C20.5707 13.9934 19.9623 14.2269 19.3947 14.2361C18.402 14.2524 17.8259 13.9589 17.3668 13.7375L17.0091 15.4679C17.4702 15.6871 18.3216 15.8775 19.2049 15.8873C21.2784 15.8873 22.6351 14.827 22.6419 13.1854ZM14.465 7.8668L11.2666 15.7638H9.17956L7.60574 9.46145C7.51009 9.07329 7.42701 8.93132 7.13644 8.7676C6.66231 8.50141 5.87854 8.25122 5.18896 8.09625L5.23606 7.8668H8.59506C9.02305 7.8668 9.4083 8.16174 9.50539 8.67187L10.3367 13.2419L12.391 7.8668H14.465Z",
    fill: "#1434CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/Visa.b7f37b6200903c719ff1d610e0d65710.svg";
export { ForwardRef as ReactComponent };